module.exports = __webpack_public_path__ + "static/191127-BS-IGB-F1-Will-of-Iron-Announcement-149ebe7e5140c3edc2c15c8e6bdea75f.jpg";